export default {
  create({ commitmentId }, data) {
    return {
      commitmentId:          commitmentId,
      streak:                1,
      hoursPlanned:          0,
      hoursWorked:           0,
      amountPlanned:         0,
      amountFinished:        0,
    };
  },

  fields: {
    commitmentId: {},
    streak: {},
    hoursPlanned: {},
    hoursWorked: {},
    amountPlanned: {},
    amountFinished: {},
  }
};
